import { BaseService } from './../_services/base.service';
import { Router , ActivatedRoute} from '@angular/router';
import { Adal5Service } from 'adal-angular5';
import { ConfigService } from './../_services/config.service';
import { Component, OnInit , NgZone } from '@angular/core';
import { LocalCacheService } from '../core/local-cache/local-cache.service';

@Component({
    templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
    public loading = true;
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private adalSvc: Adal5Service,
        private zone: NgZone,
        private storage: LocalCacheService
      ) {}
      ngOnInit() {
        const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        if (this.adalSvc.userInfo && this.adalSvc.userInfo.authenticated) {
          const returnUrl = this.storage.fetchData('returnUrl');
          this.zone.run(() => { this.router.navigateByUrl(decodeURIComponent(returnUrl)); });
          // this.router.navigateByUrl(decodeURIComponent(returnUrl));
        } else {
           this.adalSvc.login();
        }
      }
}


// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/login/login.component.ts